export default "__VITE_ASSET__CTwNQPIX__"